/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Функциональность реакции на попадание в поле зрения пользователя.
   *
   * @type {{afterRun: app.ItemInViewPortMixin.afterRun, showListening: app.ItemInViewPortMixin.showListening}}
   */
  app.ItemInViewPortMixin = {
    isInfinityListener: false,
    afterRun: function () {
      // реагируем на скроллинг
      this.listenTo(app.mainWindow, 'window.scroll', this.showListening);
      var that = this;
      setTimeout(function () {
        that.showListening();
      }, 250);
    },
    
    /**
     * Элемент отслеживает свою видимость для пользователя.
     * Элемент считается видимым пользователю если он не скрыт
     * и входит в область просмотра браузера (viewport).
     *
     * После того как элемент был просмотрен пользователем
     * отслеживать его видимость больше не требуется.
     */
    showListening: function () {
      if (this.$el.length) {
        var itemInViewport = app.helpers.DomHelper.isElementInViewport(this.$el, 0);
        if (itemInViewport && this.$el.is(':visible')) {
          if (this.model && this.model instanceof Backbone.Model) {
            this.model.set({is_viewed: true});
          }
          if( !this.isInfinityListener ) {
            // если пользователь нас уже увидел нет нужды больше следить за просмотром
            this.stopListening(app.mainWindow);
          }
        }
      }
    },
    
  };
})();

}.call(window));